webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_About__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_WareProduct__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_WareProduct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_WareProduct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Solutions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Solutions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Solutions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Dtability__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Dtability___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_Dtability__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home___default.a
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_About___default.a
  }, {
    path: '/product',
    name: 'product',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_WareProduct___default.a
  }, {
    path: '/solutions',
    name: 'solutions',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Solutions___default.a
  }, {
    path: '/dtability',
    name: 'dtability',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_Dtability___default.a
  }]
}));

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */].Store({
  modules: {}
}));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(14)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(29),
  /* scopeId */
  "data-v-18969a06",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);







__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      activeRoute: this.$route.path
    };
  },

  methods: {
    isActive: function isActive(path) {
      return path === this.activeRoute;
    }
  },
  watch: {
    '$route.path': function $routePath(newPath) {
      this.activeRoute = newPath;
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'about',
  data: function data() {
    return {
      aboutList: [{
        content: '宜昌市艾福斯信息咨询有限责任公司成立于2003年10月24日，作为获得CMMI认证的高新技术软件企业，专业从事数字化管理软件开发、能源电力行业应用软件产品研制和销售、管理软件咨询、技术服务以及信息技术软硬件产品进出口业务。'
      }, {
        content: '宜昌市艾福斯信息咨询有限责任公司管理架构包括市场拓展部、应用咨询部、技术开发部、综合行政部，拥有10多名在能源电力行业和相关信息技术领域有着15年以上产品研究、开发和咨询服务的高级业务顾问和高级程序顾问。'
      }, {
        content: '宜昌市艾福斯信息咨询有限责任公司是IFS软件在水电行业和中国区本地化的实施和技术开发战略合作伙伴，同时也是帆软企业商业智能软件和报表工具的实施合作伙伴。公司立足于先进的ERP软件、国产自主可控数据库、开源软件技术和研发工具，始终以“满足用户需求”为服务宗旨，致力于为资产密集型及项目管理型企业设计开发数字化全面解决方案，解决方案吸纳了国外大型ERP软件的管理思想和结合了中国企业的管理特点，包括完整的应用软件程序系统、业务流程标准库、信息资源管理基础标准库、报表库和配套的系统实施开发方法。经过20多年的技术研发积累和项目实施开发经验打磨，公司的核心技术与服务团队不仅具有丰富的能源电力行业管理数字化和信息技术专业知识，而且具备与国际接轨的大型软件项目实施开发的项目管理经验。'
      }]
    };
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dtability',
  data: function data() {
    return {
      text: {
        title: '研发能力',
        content: '公司在软件研发过程中遵循国际规范标准，在ISO 9001质量管理体系和ISO 27001信息安全体系平台之上，结合CMMI L3软件成熟度模型，对软件开发从开发计划、需求调用、系统设计，到研发、测试、用户培训、部署实现全过程覆盖，通过敏捷迭代开发模式实现软件过程的持续改进，提升软件开发流程工艺技术水平，增强了开发高品质软件的能力。',
        pwertText: '在电力行业主要实施ePMS系统(IFS ERP软件产品)，该系统采用面向服务的SOA三层技术架构、数据层采用oracle数据库、中间层采用java开发的中间件、用户展现层使用IFSEE企业浏览器，采用C#语言编写的用户展现界面。',
        epmsText: '实施了ePMS系统迁移到大数据云端部署，数据库从11g升级到19c，掌握oracle数据库TB级大数据量升级迁移能力，并保持系统稳定运行。根据客户提出的各种需求问题，进行了大量的接口开发及高能力技术整合。',
        taskText: '公司自主研发了任务跟踪管理系统(TASKMS)，采用最新的微服务架构，前后端分离、部署在微服务运维一体化云平台上，实现对用户各种业务任务的跟踪管理。系统采用了主流的Spring Cloud、Springboot、Nacos服务注册发现、RabbitMQ、分布式事务处理、Vue前端框架等技术栈进行敏捷迭代开发，满足用户需求的快速变化与实现。持久化方面支持多种数据库：MySQL、PostgreSQL、国产达梦和OceanBase等数据库。'
      },

      details: [{
        left: {
          title: '合理的进行服务拆分',
          content: '根据业务能力进行服务拆分根据子域进行服务拆分单一职责原则：从业务能力/子域拆分方面来理解单一职责。 闭包原则：在包中包含的所有类应该是对同类变化的一个集合，也就是说，如果对包做出修改，需要调整 的类应该都在这个包之内。'
        },
        right: {
          title: 'API优先的设计',
          content: '使用API优先方法进行设计意味着构建一个不仅仅是内部系统副产品的API。开发人员应该能够快速又轻松地了解 API的工作方式，并与其他应用程序集成在一起。只有这样，开发者才能编写优雅的代码，以便与其他系统进行有效的交互，标准 就是正确运行API时，它既向后兼容又往前扩展。'
        }
      }, {
        left: {
          title: '设计可观测的服务',
          content: '健康检查API;日志聚合;分布式跟踪'
        },
        right: {
          title: '使用微服务基底模式开发服务',
          content: '异常追踪、日志记录、健康检查、外部化配置和分布式追踪是微服务需要解决的共性问题。我们需要在能够处理那些共性问题的框架或框架集 合上构建服务。'
        }
      }, {
        left: {
          title: '微服务部署为容器',
          content: '容器是更轻量级的部署机制，是一个操作系统级的虚拟化机制。容器通常包含一个或多个在沙箱中运行的进程，这个沙箱将它们与其它容器隔离。'
        },
        right: {
          title: '开发安全的服务',
          content: '由API Gateway处理身份验证在微服务架构中使用OAuth2.0'
        }
      }]

    };
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      text: {
        title: '宜昌市艾福斯信息咨询有限责任公司',
        content: '立足于先进的ERP软件、国产自主可控数据库、开源软件技术和研发工具，始终以“满足用户需求”为服务宗旨，致力于为资产密集型及项目管理型企业设计开发数字化全面解决方案，解决方案吸纳了国外大型ERP软件的管理思想和结合了中国企业的管理特点，包括完整的应用软件程序系统、业务流程标准库、信息资源管理基础标准库、报表库和配套的系统实施开发方法。经过20多年的技术研发积累和项目实施开发经验打磨，公司的核心技术与服务团队不仅具有丰富的能源电力行业管理数字化和信息技术专业知识，而且具备与国际接轨的大型软件项目实施开发的项目管理经验。'
      }
    };
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'solutions',
  data: function data() {
    return {
      soluConents: '公司团队多年来在核电、火电、水电、风电、采矿等资产密集型企业信息化实施开发的经验反复验证和表明，一个成功的企业管理信息化项目全面解决方案，必须完整包括所选用软件平台、行业支撑知识库、实施方法论，这三者缺一不可，构成对解决方案三位一体的托举支撑。公司目前已培育成熟“电力企业ERP数字化管理解决方案”和“大数据商业智能解决方案”两个完整的解决方案能够快速实施部署和交付给目标客户。',
      solutionsList: [{
        name: '电力企业ERP数字化管理解决方案',
        description: '公司和长江电力通过长期合作共研的ePMS系统已发展成为一个电力企业ERP数字化管理解决方案，是一个多公司管理架构下的以电站资产维护管理和企业经营管理为双核心的大型ERP数字化管理平台，能同时满足企业集团化下跨区域大型电站群及梯级流域电站生产管理和以人财物为优化对象的企业经营管理的需要。'
      }, {
        name: '大数据商业智能解决方案',
        description: '商业智能（BI）现代数据仓库技术、线上分析处理技术、数据挖掘和数据展现技术进行数据分析以实现商业价值，通过处理企业中现有数据，并将其转换成知识、分析和结论，辅助业务或者决策者做出正确的决定。'
      }]
    };
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'product',
  data: function data() {
    return {

      productList: [{
        name: '设备试验管理',
        description: '设备试验管理包括试验数据管理、试验设备管理和试验综合分析3个方面，设备试验数据管理用来管理所有试验设备的试验信息；试验设备管理包括试验设备的基本信息管理、试验类型、试验周期和运行参数信息管理；试验综合分析通过不同的方法和角度来分析设备试验历史数据，获得有用的价值信息，为决策提供支持。'
      }, {
        name: '运行管理',
        description: '运行调度管理模块是规范运行值班、安全作业等相关业务，完成对外部系统与各子系统的实时和统计数据的收集和整合，为运营调度、安全生产等提供数据基础和决策依据。'
      }, {
        name: '安全可靠性管理',
        description: '安全可靠性管理由安全管理文件、安全活动管理、应急管理、安全人员教育与资质管理、特种设备管理、安全事故管理、环境保护和职业健康安全管理、可靠性管理和安全基础数据等几个部分组成。主要用于管理生产过程中与安全相关的事务性流程、相关记录与文件。'
      }, {
        name: '故障树管理',
        description: '故障树是指根据设备类型建立的故障现象、故障原因、解决措施等的层次结构，是对检修、维护工作的总结，对设备维修工作具有一定的指导意义。'
      }, {
        name: 'eKPI系统',
        description: '基于BI软件的企业绩效指标展示平台。'
      }, {
        name: '工会费用报销系统',
        description: '费用报销管理的工会版本。'
      }, {
        name: '检修项目管理',
        description: '检修项目管理要以标准化管理和项目管理为指导，实现标准检修项目的管理和执行检修项目的管理，对电站多设备集中检修的计划和执行进行有效的管理和监控。'
      }, {
        name: '检修记录管理',
        description: '检修记录管理主要是进行实现设备检修记录信息的录入管理以及对应的检修记录信息录入管理，形成结构化数据并生成相关WORD版本的检修记录报告及数据分析等内容的管理和维护的业务需求。'
      }, {
        name: '评标专家管理',
        description: '评标专家、专家评价记录、参加招标历史等的查询、创建、修改、审批等操作，维护与评标专家相关的各关联对象，维护与外部系统接口。'
      }, {
        name: '供应商评价管理',
        description: '主要根据供应商的分类和相关的业务情况建立相应的评价标准并执行年度评价。'
      }, {
        name: '合同管理',
        description: '合同的查询、创建、修改、审批、同步、状态流转等操作，维护与合同相关的各关联对象，维护与外部系统的接口。'
      }, {
        name: '财务共享平台',
        description: '基于信息系统的应用设置实现共享业务事务数据、共享财务核算数据和共享财务核算人力资源，建立财务核算任务管理，可以灵活配置，任务分配和领取并为财务核算统计提供依据。'
      }, {
        name: '财务报销管理',
        description: '费用报销模块实现了员工执行费用报销从申报到执行全过程管理，并引入企业相关定额规范控制过程，打通与商旅系统以及OCR接口。'
      }, {
        name: '融资管理',
        description: '融资管理包括融资基础数据管理、融资项目管理、融资项目变更管理、计提与摊销管理、外部系统接口等。'
      }, {
        name: '资金预算管理',
        description: '资金预算主要包括资金预算的申报与审批，各相关部门对自己下月需要的资金按照固定的申报模板进行填写申报，对申报好的资金预算各层领导对申报的资金进行审批。'
      }, {
        name: '财务自动核算平台',
        description: '实现业财一体化，建立业务到财务的数据流转化，建立以下自动核算功能：物资库存核算、采购支付核算、费用报销核算、项目核算、固定资产核算、薪酬核算、电能销售核算、房产税、印花税计提、融资核算和通用制证等。'
      }, {
        name: '费用定额管理',
        description: '主要包括费用预算标准定额和费用执行定额来实现费用定额的标准定义。费用预算标准定额为计划预算的申报提供依据和标准，费用执行定额为费用报销提供依据和标准。'
      }, {
        name: '考勤管理',
        description: '通过对请休假管理、加班管理、年休假计划、日常考勤等功能的操作完成考勤的全过程管理。以及考勤基础数据的维护功能都是在该模块内完成。'
      }, {
        name: '实物资产管理',
        description: '企业实物资产全流程管理，包括资产卡片、资产变更、资产移动、资产合并、资产拆分、资产报废、资产处置等。'
      }, {
        name: '资产移动盘点管理',
        description: '移动终端固定资产清查系统主要实现ePMS系统无法或不便参与的实际业务操作，为物资管理实际操作人员提供便利服务，如数据采集、基础数据查询等，作为ePMS物资管理的一个插件，提高ePMS系统的应用价值，物资管理的实际操作带来便利，提高效率。'
      }, {
        name: '运行移动巡检管理',
        description: '对一系列设备在同一个许可下进行维护检修，可将多个设备排成检修路线，按不同的路线来检查不同设备以获得最大效率。每个路线由路线中单个设备的分立的PM操作组成。在路线中可以为每个PM操作指定不同的事件及监测标准。'
      }]

    };
  }
});

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/polic-log.d0289dc.png";

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(18)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(33),
  /* scopeId */
  "data-v-6c94c7e7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(15)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(30),
  /* scopeId */
  "data-v-2d04cb74",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(17)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(32),
  /* scopeId */
  "data-v-5f7ae116",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(16)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(31),
  /* scopeId */
  "data-v-3cbbf218",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(19)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(34),
  /* scopeId */
  "data-v-f3bc67e8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('header', {
    staticClass: "header-area single-page"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "main-menu main-menu-light"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.isActive('/')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("主页")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/product')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/product"
    }
  }, [_vm._v("软件产品")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/dtability')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/dtability"
    }
  }, [_vm._v("研发能力")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/solutions')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/solutions"
    }
  }, [_vm._v("解决方案")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/about')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("关于我们")])], 1)])])])])])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('router-view'), _vm._v(" "), _vm._m(4)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "spinner"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2"
  }, [_c('div', {
    staticClass: "logo-area"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-navbar"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title text-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer-area section-padding footer-area-color"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row-foot"
  }, [_c('div', [_c('div', [_c('ul', [_c('li', [_vm._v("宜昌市艾福斯信息咨询有限责任公司")]), _vm._v(" "), _c('li', [_vm._v("\n                  宜昌高新区城东大道18-2-420号福海花园\n                   电话：0717-6331139\n                ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "rgba(255, 255, 255, 0.88)"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("鄂ICP备2023004624号")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a', {
    staticStyle: {
      "height": "20px",
      "line-height": "20px",
      "margin": "0px 0px 0px 5px",
      "color": "rgba(255, 255, 255, 0.88)"
    },
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42050202000791"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "auto",
      "margin-bottom": "4px"
    },
    attrs: {
      "src": __webpack_require__(23)
    }
  }), _vm._v("鄂公网安备 42050202000791号")])])])])])])])])])
}]}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "sample-text-area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "text-heading title_color"
  }, [_vm._v(_vm._s(_vm.text.title))]), _vm._v(" "), _c('p', {
    staticClass: "sample-text text-color"
  }, [_vm._v("\n        " + _vm._s(_vm.text.content) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "div-card fadeIn animated"
  }, [_c('p', {
    staticClass: "sample-text text-color card"
  }, [_vm._v("\n                   " + _vm._s(_vm.text.pwertText) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "sample-text text-color card"
  }, [_vm._v("\n                  " + _vm._s(_vm.text.epmsText) + "\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "whole-wrap warp-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "sample-text text-color"
  }, [_vm._v(_vm._s(_vm.text.taskText) + "\n      ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.details), function(v, i) {
    return _c('div', {
      key: i,
      staticClass: "container"
    }, [_c('div', {
      staticClass: "section-top-border fadeInLeft animated"
    }, [_c('h3', {
      staticClass: "mb-30 title_color"
    }, [_vm._v(_vm._s(v.left.title))]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-9 mt-sm-20 left-align-p"
    }, [_c('p', [_vm._v(_vm._s(v.left.content))])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-top-border text-right fadeInRight animated"
    }, [_c('h3', {
      staticClass: "mb-30 title_color"
    }, [_vm._v(_vm._s(v.right.title))]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-9"
    }, [_c('p', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(v.right.content))])]), _vm._v(" "), _vm._m(2, true)])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _c('br'), _vm._v("采用领域驱动设计(DDD)的软件开发设计方法，实现对用户业务需求进行微服务拆分。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 row-img"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/elements/d.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 row-img"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/elements/dr.png",
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "pricing-table section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 fadeInLeftBig animated"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('p', {
    staticClass: "row-p"
  }, [_vm._v(_vm._s(_vm.soluConents))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row fadeInRightBig animated"
  }, _vm._l((_vm.solutionsList), function(v, i) {
    return _c('div', {
      key: i,
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "single-table text-center mb-4 mb-md-0"
    }, [_c('div', {
      staticClass: "table-top"
    }, [_c('h3', [_vm._v(_vm._s(v.name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "30px"
      }
    }, [_vm._v("\n              " + _vm._s(v.description) + "\n            ")])])])
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "66vh"
    }
  }, [_c('section', {
    staticClass: "banner-area"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 align-self-center fadeIn animated"
  }, [_c('div', {
    staticClass: "banner-text"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.text.title))]), _vm._v(" "), _c('p', {
    staticClass: "py-3 text-line"
  }, [_vm._v("\n                      " + _vm._s(_vm.text.content) + "\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 px-0"
  }, [_c('div', {
    staticClass: "banner-bg"
  })])
}]}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-bg"
  }, [_c('section', {
    staticClass: "employee-area section-padding zoomIn animated"
  }, [_c('div', {
    staticClass: "container row-li"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', [_vm._v("宜昌艾福斯")]), _vm._v(" "), _vm._l((_vm.aboutList), function(v, i) {
    return _c('ul', {
      key: i,
      staticClass: "mt-4 section-content"
    }, [_c('li', {
      staticClass: "mb-3"
    }, [_vm._v(_vm._s(v.content))])])
  })], 2)])])])])])
},staticRenderFns: []}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "jobs-area section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.productList), function(v, i) {
    return _c('div', {
      key: i,
      staticClass: "col-lg-12",
      attrs: {
        "id": "square"
      }
    }, [_c('div', {
      staticClass: "single-job mb-4 d-lg-flex justify-content-between fadeInUp animated"
    }, [_c('div', {
      staticClass: "job-text"
    }, [_c('h4', [_vm._v(_vm._s(v.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(v.description))])]), _vm._v(" "), _vm._m(0, true)])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job1.png",
      "alt": "job"
    }
  })])
}]}

/***/ })
],[7]);


// WEBPACK FOOTER //
// static/js/app.421c384961ab6ed9260f.js